import React from "react";
function TagExtension() {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v3-conversation--tag-extension">
          <div className="app-v3-conversation--tag-extension--title">
            Tiện ích nhãn
          </div>
          <div className="app-v3-conversation--tag-extension--action">
            <div className="app-settings-tab-content--header">
              <div className="app-settings-tab-content--header--actions">
                <button
                  type="button"
                  className="app-btn app-btn-default app-v3-btn--h-36 app-v3-conversation--comments--header--actions--cancel"
                >
                  Huỷ
                </button>
                <button
                  type="button"
                  className="app-btn app-btn-primary app-btn-action app-v3-btn--h-36 app-v3-conversation--comments--header--actions--save"
                >
                  <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M11.727 2.393A1.338 1.338 0 0010.78 2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V5.22c0-.353-.14-.693-.393-.94l-1.88-1.887zM8 12.667c-1.107 0-2-.894-2-2 0-1.107.893-2 2-2s2 .893 2 2c0 1.106-.893 2-2 2zM4.667 6h4C9.4 6 10 5.4 10 4.667c0-.734-.6-1.334-1.333-1.334h-4c-.734 0-1.334.6-1.334 1.334C3.333 5.4 3.933 6 4.667 6z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>Lưu</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="app-v2-layout-content app-v3-conversation--tag-extension--container">
          <div className="app-settings-tab-content">
            <div className="app-settings-tab-content--container">
              <div
                id="app-settings-tab--extension"
                className="app-settings-tab-content--body"
              >
                <div className="app-settings-tab-content--item">
                  <div className="app-settings-tab-content--item--wrapper">
                    <div className="app-settings-tab-content--item__content">
                      <div className="app-settings-tab-content--item__content--title">
                        Tự động đồng bộ nhãn từ Facebook về Viettel Social
                      </div>
                      <div className="app-settings-tab-content--item__content--desc">
                        Hệ thống sẽ tự động đồng bộ nhãn một chiều từ Facebook
                        về Viettel Social
                      </div>
                    </div>
                    <div className="app-settings-tab-content--item__action">
                      <button
                        type="button"
                        className="app-switch app-switch-disabled"
                      >
                        <span className="app-switch-inner"></span>
                        <div className="app-click-animating-node"></div>
                      </button>
                    </div>
                  </div>
                  <div className="mt12">
                    <div className="app-alert-container info">
                      <div className="app-alert-container__block">
                        <div
                          className="app-alert--icon ic-warning-circle"
                          style={{
                            backgroundSize: "14px",
                            width: "14px",
                            height: "14px",
                          }}
                        ></div>
                        <p>
                          <b></b>Bạn cần chấp thuận điều khoản của Facebook để
                          sử dụng chức năng đồng bộ nhãn từ Facebook về
                          Viettel Social
                          <br />
                        </p>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary app-settings-tab-content-btn__info-tos"
                      >
                        Xem thông tin
                      </button>
                    </div>
                  </div>
                </div>
                <div className="app-settings-tab-content--item">
                  <div className="app-settings-tab-content--item--wrapper">
                    <div className="app-settings-tab-content--item__content">
                      <div className="app-settings-tab-content--item__content--title">
                        Tự động gắn nhãn vào hội thoại có chứa số điện thoại
                      </div>
                      <div className="app-settings-tab-content--item__content--desc">
                        Hệ thống sẽ gắn nhãn cho bạn biết hội thoại có chứa số
                        điện thoại.
                      </div>
                    </div>
                    <div className="app-settings-tab-content--item__action">
                      <button type="button" className="app-switch">
                        <span className="app-switch-inner"></span>
                        <div className="app-click-animating-node"></div>
                      </button>
                    </div>
                  </div>
                  <div className="app-settings-tab-content--item-tag-has-phone">
                    <div className="app-settings-tab-content--item-tag-has-phone--warning">
                      <div className="app-settings-tab-content--item-tag--title">
                        Tên nhãn
                      </div>
                    </div>
                    <div>
                      <div className="app-settings-tab-content--item-tag-has-phone-input">
                        <div className="app-stack app-stack--size-small app-stack--align-center">
                          <div className="app-stack--item app-stack--item-fill app-settings-tab-content--item-tag-has-phone-placeholder">
                            Chọn nhãn
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="app-settings-auto-tag-has-keyword--section">
                  <div className="app-settings-auto-tag-has-keyword--top">
                    <div className="app-settings-auto-tag-has-keyword--top__content">
                      <div className="app-settings-auto-tag-has-keyword--top__content--title">
                        Tự động gắn nhãn vào hội thoại có chứa Từ khóa
                      </div>
                      <div className="app-settings-auto-tag-has-keyword--top__content--desc">
                        Hệ thống sẽ gắn nhãn vào hội thoại có chứa từ khoá mà
                        bạn muốn phân loại. Hãy nhập tên nhãn để gắn lên hội
                        thoại và từ khoá để phân loại nếu trong nội dung hội
                        thoại có chứa.
                      </div>
                    </div>
                    <div className="app-settings-auto-tag-has-keyword--top__action">
                      <button type="button" className="app-switch">
                        <span className="app-switch-inner"></span>
                        <div className="app-click-animating-node"></div>
                      </button>
                    </div>
                  </div>
                  <div className="app-list-label-has-keyword--list">
                    <div className="app-list-label-has-keyword--addnew">
                      <button
                        type="button"
                        className="app-btn app-btn-link app-btn-pd-none app-list-label-has-keyword--btn-addnew"
                      >
                        <svg
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#2962FF"
                            fillRule="evenodd"
                            d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 4.166a.836.836 0 00-.834.834v2.5h-2.5a.836.836 0 00-.833.833c0 .458.375.833.833.833h2.5v2.5c0 .458.375.833.834.833a.836.836 0 00.833-.833v-2.5h2.5a.836.836 0 00.833-.833.836.836 0 00-.833-.833h-2.5v-2.5A.836.836 0 0010 5.833zM3.333 10A6.675 6.675 0 0010 16.666 6.675 6.675 0 0016.666 10 6.676 6.676 0 0010 3.333 6.676 6.676 0 003.333 10z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        <span>Thêm nhãn khác</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TagExtension;
